import React, { Component } from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';

import AppSwitch from './AppSwitch';
import AuthGate from './Authentication/AuthGate';
import EsmsPublic from './EsmsPublic';

export default class App extends Component {
    componentDidMount() {
    }

    render() {
        return (
            <React.Fragment>
                <CssBaseline />
                <AuthGate
                    authComponent={AppSwitch}
                    unauthComponent={EsmsPublic}
                    render={({
                        Component,
                        session,
                        signIn,
                        signOut
                    }) => (
                        <Component
                            session={session}
                            signIn={signIn}
                            signOut={signOut}
                        />
                    )}
                />
            </React.Fragment>
        );
    }
}
